import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AUTH_ROUTES } from '../../auth/constants/auth-routes.constants';
import { AppRouteNavigationService } from '../services/app-route-navigation.service';
import { AuthService } from '../../auth/services/auth/auth.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const appRouteNavigation = inject(AppRouteNavigationService);
  const authService = inject(AuthService);

  if (authService.isAuthenticated()) {
    return true;
  }

  const safeRedirect =
    authService.sanitizePostLoginRedirect(state.url) ?? state.url;
  authService.setPostLoginRedirect(safeRedirect);
  return appRouteNavigation.createUrlTree(AUTH_ROUTES.login, {
    queryParams: { redirectTo: safeRedirect },
  });
};
